if (!customElements.get('product-ships-in')) {
  customElements.define(
    'product-ships-in',
    class ProductShipsIn extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.textEl = this.querySelector('[data-ships-in-text]');
        const variantsEl = this.querySelector('[data-variant-availability]');
        const productAvailabilityEl = this.querySelector('[data-product-availability]');

        if (!this.textEl || !variantsEl || !productAvailabilityEl) return;

        this.variants = JSON.parse(variantsEl.textContent);
        this.productAvailability = JSON.parse(productAvailabilityEl.textContent);

        this.update(this.dataset.initialVariantId);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId && event.data.variant?.id) {
            this.update(event.data.variant.id);
          }
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      shipsInForVariant(variant) {
        const variantAvailability = variant.availability;

        if (!variant.inventory_management) {
          if (variantAvailability) return `${variantAvailability} Days`;
          if (this.productAvailability) return `${this.productAvailability} Days`;
          return 'Contact Us For Updated ETA';
        }

        if (variant.inventory_quantity > 0 && variant.available) return '24-72 Hours';
        if (variantAvailability) return `${variantAvailability} Days`;
        if (this.productAvailability) return `${this.productAvailability} Days`;
        return 'Contact Us For Updated ETA';
      }

      update(variantId) {
        const variant = this.variants.find((entry) => String(entry.id) === String(variantId));
        if (variant) {
          this.textEl.textContent = this.shipsInForVariant(variant);
        }
      }
    }
  );
}
